/**
 * @param value
 * @return {boolean}
 */
export default function IsEmpty(value) {
  return (!value || value === '' || (Array.isArray(value) && value.length === 0) || (typeof value === "object" && Object.keys(value).length === 0))
}
